const cache = new WeakMap();
export function isWebGL2(gl) {
    if (cache.has(gl)) {
        return cache.get(gl);
    }
    else {
        const value = gl.getParameter(gl.VERSION).startsWith('WebGL 2.0');
        cache.set(gl, value);
        return value;
    }
}
//# sourceMappingURL=webgl2.js.map